import dayjs from "@dayjs";
import { Dayjs } from "dayjs";
import { isEmpty } from "lodash";
import { useLocale, useTranslations } from "next-intl";
import React from "react";

interface DateInputProps {
  departOnly?: boolean;
  departDate: string;
  returnDate: string;
  onClickDepart: () => void;
  onClickReturn: () => void;
}

const DateInput: React.FC<DateInputProps> = ({
  departOnly = false,
  departDate,
  returnDate,
  onClickDepart,
  onClickReturn,
}) => {
  const t = useTranslations();
  const locale = useLocale();
  const formatDisplayDate = (date: string, locale: string): string => {
    if (!date || isEmpty(date)) {
      return "";
    }

    if (locale === "en") {
      return dayjs(date).format("ddd, MMM D");
    }

    return dayjs(date).format("YYYY-MM-DD");
  };

  return (
    <div className="flex gap-2 flex-grow">
      <label
        className="flex items-center rounded-full border border-sleap-gray-400 flex-grow cursor-pointer"
        onClick={onClickDepart}
      >
        <span className="font-semibold font-switzer text-base text-sleap-gray-950 dark:text-white pl-6 text-nowrap">
          {t("Other.depart")}
        </span>{" "}
        <input
          type="text"
          readOnly
          className="pe-2 py-4 h-12 outline-none w-full rounded-full font-switzer text-base bg-transparent ms-2"
          value={
            departDate
              ? formatDisplayDate(departDate, locale)
              : t("Other.selectDate")
          }
        />
      </label>

      {!departOnly && (
        <label
          className="flex items-center rounded-full border border-sleap-gray-400 flex-grow cursor-pointer"
          onClick={onClickReturn}
        >
          <span className="font-semibold font-switzer text-base text-sleap-gray-950 dark:text-white text-nowrap pl-6">
            {t("Other.return")}
          </span>
          <input
            type="text"
            readOnly
            className="px-2 py-4 h-12 outline-none w-full rounded-full font-switzer text-base bg-transparent"
            value={
              returnDate
                ? formatDisplayDate(returnDate, locale)
                : t("Other.selectDate")
            }
            disabled={!departDate}
          />
        </label>
      )}
    </div>
  );
};

export default DateInput;
